import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import resolvePath from '../../../misc/resolvePath';

function RelativeRedirect(props) {
    const { to , ...otherProps} = props,
        { pathname } = useLocation();

    return <Redirect to={resolvePath(pathname, to)} {...otherProps}  />;
}

export default RelativeRedirect;
